import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
// import Footer from './Footer';
import './UIUXPage.css';   // Use UIUX CSS instead of Cloud CSS

const CloudServicesPage = () => {

  // Scroll to top on load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="uiux-page">
        <div className="uiux-container">

         {/* Back Button */}
         <div className="back-link">
          <Link 
           to="/" 
          style={{ textDecoration: "none", fontSize: "18px", cursor: "pointer", color: "black" }}
  >
          ← Back to Home
         </Link>
         </div>


          {/* Header */}
          <div className="uiux-header">
            <h1>Cloud Services</h1>
            <p className="uiux-subtitle">
              Empower your business with scalable, secure, and cost-effective
              cloud solutions. We help organizations modernize infrastructure,
              improve agility, and optimize operational efficiency through
              tailored cloud strategies.
            </p>
          </div>

          <div className="uiux-content">

            {/* Section */}
            <section className="uiux-section">
              <h2>What We Offer</h2>

              <div className="uiux-service">
                <h3>Cloud Architecture Design</h3>
                <p>
                  We design scalable and secure cloud infrastructures that
                  support high availability, resilience, and future growth.
                </p>
              </div>

              <div className="uiux-service">
                <h3>Cloud Migration Services</h3>
                <p>
                  Seamless migration of applications, databases, and workloads
                  from on-premise or legacy systems to modern cloud platforms.
                </p>
              </div>

              <div className="uiux-service">
                <h3>Cloud Optimization & Cost Management</h3>
                <p>
                  We optimize performance and control cloud spend through
                  resource monitoring, scaling strategies, and cost governance.
                </p>
              </div>

              <div className="uiux-service">
                <h3>Cloud Security & Compliance</h3>
                <p>
                  Implementation of encryption, IAM policies, and compliance
                  frameworks to secure cloud environments and data assets.
                </p>
              </div>

              <div className="uiux-service">
                <h3>DevOps & Automation</h3>
                <p>
                  CI/CD pipelines, containerization, and infrastructure
                  automation accelerate deployment cycles and reliability.
                </p>
              </div>

            </section>

            {/* Platforms */}
            <section className="uiux-section">
              <h2>Supported Platforms</h2>

              <div className="tools-grid">

                <div className="tool-category">
                  <h4>Amazon Web Services</h4>
                </div>

                <div className="tool-category">
                  <h4>Microsoft Azure</h4>
                </div>

                <div className="tool-category">
                  <h4>Google Cloud Platform</h4>
                </div>

                <div className="tool-category">
                  <h4>IBM Cloud</h4>
                </div>

                <div className="tool-category">
                  <h4>Oracle Cloud Infrastructure</h4>
                </div>

              </div>
            </section>

          </div>
        </div>
      </div>

      {/* <Footer /> */}
    </>
  );
};

export default CloudServicesPage;
